import React from 'react';
import SectionChart from "./home/SectionChart";
import SectionBoxes from "./home/SectionBoxes";
import SectionTV from "./home/SectionTV";
import SectionHero from "./home/SectionHero";
import SectionSubscriptions from "./home/SectionSubscriptions";
import SecureCheckout from "./home/SecureCheckout";
import AffiliateProgram from "./home/AffiliateProgram";
import Faq from "./home/Faq";

const Home = () => {

    return (
        <>
            <SectionHero />
            <SectionTV />
            <SectionBoxes />
            <SectionChart />
            <SectionSubscriptions />
            <SecureCheckout />
            <AffiliateProgram />
            <Faq page="home" />
        </>
);
};

export default Home;